import LegalDocument from "../components/LegalDocument";
import smokeSignalContent from "../content/smokeSignalTerms";

export default function SmokeSignalTerms() {
  return (
    <LegalDocument
      pageTitle="Smoke Signal Terms of Service"
      content={smokeSignalContent}
    />
  );
}
